import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const animateStepperNumbers = (stepsRef) => {
  if (stepsRef.current[0]?.dataset.animated === 'true') {
    return;
  }

  stepsRef.current.forEach((step, index) => {
    const stepperItem = step;
    const numberElement = step.querySelector('.number h3');
    const contentElement = step.querySelector('.StepContent');
    
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: step,
        start: 'top bottom-=100',
        end: 'bottom top+=100',
        toggleActions: 'play none none none',
        once: true,
        onEnter: () => {
          step.dataset.animated = 'true';
        },
      }
    });

    tl.fromTo(
      [stepperItem, numberElement, contentElement],
      { 
        opacity: 0, 
        y: 50 
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power3.out',
        stagger: 0.2,
      }
    );
  });
};

export const animateStepperNumbersColor = (stepsRef) => {
  stepsRef.current.forEach((step) => {
    const numberElement = step.querySelector('.number h3');
    
    gsap.to(numberElement, {
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut',
      onUpdate: function () {
        const progress = this.progress();
        const lightness = Math.round(progress * 100);
        gsap.set(numberElement, {
          color: `hsl(0, 0%, ${lightness}%)`,
        });
      },
      scrollTrigger: {
        trigger: step,
        start: 'top bottom',
        end: 'bottom top',
        toggleActions: 'play pause resume pause',
      },
    });
  });
};

export const cleanupStepperAnimations = () => {
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.vars.trigger.classList.contains('StepperItem')) {
      trigger.kill();
    }
  });
};
